<template>
  <div v-show="isLoading" class="loading">
    <v-progress-circular :size="70" color="primary" indeterminate />
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * ローディング表示可否を取得する
     */
    isLoading: {
      cache: false,
      get() {
        return this.$store.getters['loading/isLoading'];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  z-index: 9999;
  position: fixed;
  background-color: rgba(#000, 0.3);
}
</style>
